import { create } from 'zustand';

interface PadState {
  /** The quick-phrase pad is open (it also opens from its key). */
  open: boolean;
  toggle: () => void;
  set: (open: boolean) => void;
}

export const usePadStore = create<PadState>((set) => ({
  open: false,
  toggle: () => set((s) => ({ open: !s.open })),
  set: (open) => set({ open }),
}));
